module.exports = __webpack_public_path__ + "img/DClogo.d36a8743.png";